import React from 'react';
import {Snackbar, Icon, SnackbarContent} from '@material-ui/core';
import { amber, blue} from '@material-ui/core/colors';
import {useDispatch, useSelector} from 'react-redux';
import clsx from 'clsx';
import * as Actions from 'app/store/actions';
import {makeStyles} from '@material-ui/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import WarningIcon from '@material-ui/icons/Warning';

const useStyles = makeStyles(theme => ({
    root   : {
        '& .MuiSnackbar-root':{
            padding:0,
        },
        '& .MuiSnackbarContent-message':{
            width: '100% !important',
            padding:0,
        }
    },
    success: {
        backgroundColor: '#DCFCE7',
        color          : '#183560',
        borderRadius   : '8px'
    },
    error  : {
        backgroundColor: '#FEE2E2',
        color          : '#183560',
    },
    info   : {
        backgroundColor: blue[600],
        color          : '#FFFFFF'
    },
    warning: {
        backgroundColor: '#FEF3C7',
        color          : '#183560',
    },
}));

const variantIcon = {
    success: <CheckCircleIcon style={{color:'#22C55E'}} />,
    warning: <WarningIcon style={{color:'#F59E0B'}} />,
    error  : <CancelIcon style={{color:'#EF4444'}} />,
    info   : "info"
};

function FuseMessage(props)
{
    const dispatch = useDispatch();
    const state = useSelector(({fuse}) => fuse.message.state);
    const options = useSelector(({fuse}) => fuse.message.options);

    const classes = useStyles();

    return (
        <Snackbar
            {...options}
            open={state}
            onClose={() => dispatch(Actions.hideMessage())}
            className={classes.root}
            ContentProps={{
                variant        : 'body2',
                headlineMapping: {
                    body1: 'div',
                    body2: 'div'
                }
            }}
        >
            <SnackbarContent
                className={clsx(classes[options.variant], "flex max-w-md lg:max-w-lg w-full p-0")}                
                message={
                <div className="flex w-full spacex-x-4">                   
                    <div className="flex justify-center items-start p-16 text-center font-bold space-x-5">
                        {variantIcon[options.variant] && (                            
                            variantIcon[options.variant]
                        )}                        
                        <div className="m-auto">
                        {options.message}
                        </div>                    
                    </div>
                    <div className='flex-1 m-auto text-end'>
                    <Icon 
                        fontSize="small" 
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        className="self-end mt-8 mr-8 text-neutrals-400"
                        onClick={() => dispatch(Actions.hideMessage())}
                    >
                        close
                    </Icon>
                    </div>
                   
                </div>         
            }>
            
        </SnackbarContent>
        </Snackbar>
    );
}

export default React.memo(FuseMessage);
